import React, { useState, useEffect } from 'react';
import { getCases, deleteCase } from '../services/casesService';
import CaseFormNew from './CaseFormNew';
import './CaseTree.css';
import { API_BASE_URL } from '../config/apiConfig';
const CaseTree = () => {
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedParents, setExpandedParents] = useState(new Set());
  const [showForm, setShowForm] = useState(false);
  const [creatingChildFor, setCreatingChildFor] = useState(null);
  const URL_NO_API = API_BASE_URL.replace('/api', '');
  useEffect(() => {
    loadCases();
  }, []);

  const loadCases = async () => {
    try {
      setLoading(true);
      const data = await getCases();
      setCases(data);
    } catch (error) {
      console.error('Error loading cases:', error);
      alert('Error al cargar casos');
    } finally {
      setLoading(false);
    }
  };

  const toggleParent = (parentId) => {
    const newExpanded = new Set(expandedParents);
    if (newExpanded.has(parentId)) {
      newExpanded.delete(parentId);
    } else {
      newExpanded.add(parentId);
    }
    setExpandedParents(newExpanded);
  };

  const handleCreateChild = (parentId) => {
    setCreatingChildFor(parentId);
    setShowForm(true);
  };

  const handleDelete = async (caseId) => {
    if (!window.confirm('¿Estás seguro de que quieres eliminar este caso?')) {
      return;
    }

    try {
      await deleteCase(caseId);
      await loadCases(); // Recargar la lista
    } catch (error) {
      console.error('Error deleting case:', error);
      alert('Error al eliminar el caso');
    }
  };

  const handleFormCreated = () => {
    loadCases();
    setShowForm(false);
    setCreatingChildFor(null);
  };

  const handleFormCancel = () => {
    setShowForm(false);
    setCreatingChildFor(null);
  };

  const renderCaseCard = (caseItem, isChild = false) => {
    const hasChildren = caseItem.children && caseItem.children.length > 0;
    const isExpanded = expandedParents.has(caseItem.id);

    return (
      <div key={caseItem.id} className={`case-tree-item ${isChild ? 'case-child' : 'case-parent'}`}>
        <div className="case-card">
          <div className="case-header">
            <div className="case-info">
              <h3>{caseItem.client_name}</h3>
              <p className="case-date">
                {new Date(caseItem.created_at).toLocaleDateString('es-ES')}
              </p>
            </div>
            <div className="case-actions">
              {hasChildren && (
                <button
                  onClick={() => toggleParent(caseItem.id)}
                  className="btn-toggle"
                >
                  {isExpanded ? '▼' : '▶'} ({caseItem.children.length})
                </button>
              )}
              <button onClick={() => handleCreateChild(caseItem.id)} className="btn-add-child">
                + Hijo
              </button>
              <button onClick={() => handleDelete(caseItem.id)} className="btn-delete">
                Eliminar
              </button>
            </div>
          </div>

          <p className="case-description">{caseItem.description}</p>

          {caseItem.media && caseItem.media.length > 0 && (
            <div className="case-media">
              <h4>Media ({caseItem.media.length})</h4>
              <div className="media-grid">
                {caseItem.media.slice(0, 4).map((media, index) => (
                  <div key={index} className="media-item">
                    {media.type === 'image' ? (
                      <img src={`${URL_NO_API}/storage/${media.path}`} alt={`${caseItem.client_name} - ${index + 1}`} />
                    ) : (
                      <video src={`${URL_NO_API}/storage/${media.path}`} controls />
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {hasChildren && isExpanded && (
          <div className="case-children">
            {caseItem.children.map(child => renderCaseCard(child, true))}
          </div>
        )}
      </div>
    );
  };

  if (loading) {
    return <div className="loading">Cargando casos...</div>;
  }

  const parentCases = cases.filter(c => c.parent_id === null);

  return (
    <div className="case-tree">
      {showForm && (
        <div className="form-overlay">
          <CaseFormNew
            parentId={creatingChildFor}
            onCreated={handleFormCreated}
            onCancel={handleFormCancel}
          />
        </div>
      )}

      <div className="case-tree-header">
        <h2>Casos</h2>
        <button className="btn-create" onClick={() => setShowForm(true)}>
          Crear Caso Padre
        </button>
      </div>

      {parentCases.length === 0 ? (
        <div className="cases-empty">
          <p>No hay casos registrados aún.</p>
          <p className="empty-subtitle">Crea tu primer caso padre para comenzar.</p>
        </div>
      ) : (
        <div className="case-tree-list">
          {parentCases.map(parent => renderCaseCard(parent))}
        </div>
      )}
    </div>
  );
};

export default CaseTree;